import React, { Component } from 'react'
import { Typeahead, Menu, MenuItem } from 'react-bootstrap-typeahead'

import { injectIntl } from 'react-intl'
import messages from './messages'
import APPURL from 'utils/app/urls'
import RegionTools from 'utils/regions/regionTools'
import ObjectTools from 'utils/objects/objectTools'

import Loading from 'components/Loading'

class RegionChangerController extends Component {
  constructor(props) {
    super(props)

    const {
      intl: { formatMessage }
    } = props
    this.formatMessage = formatMessage

    this.state = {
      selected: [],
      loading: true,
      regionsDataByCountry: null
    }
  }

  componentDidMount() {
    if (this.state.loading) {
      if (this.props.regionsData && this.props.countriesData) {
        const regionsDataByCountry = RegionTools.getRegionsDataByCountry(this.props.regionsData)
        this.setState({ loading: false, regionsDataByCountry })
      }
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (!this.state.regionsDataByCountry) {
      if (this.state.loading) {
        if (this.props.regionsData && this.props.countriesData) {
          const regionsDataByCountry = RegionTools.getRegionsDataByCountry(this.props.regionsData)
          this.setState({ loading: false, regionsDataByCountry })
        }
      }
    } else if (!ObjectTools.compareObjects(this.state.selected, prevState.selected)) {
      setTimeout(() => {
        this.props.setSelectedRegionId(this.state.selected[0].id)
        this.setState({ loading: false })
      }, 1000)
    }
  }

  handleChange(selected) {
    selected = this.handleMultiple(selected)
    if (selected.length > 0) {
      const selectedCode = selected[0].code
      let oldURL = this.props.history.location.pathname
      let newURL = APPURL.getSameURLWithChangedRegion({ url: oldURL, regionCode: selectedCode })
      if (oldURL !== newURL) {
        this.props.history.push(newURL)
      }
      this.setState({ selected, loading: true })
    }
  }

  handleMultiple(selected) {
    if (!this.props.multiple) {
      if (selected.length > 1) {
        selected.shift()
      }
    }
    return selected
  }

  renderMenu(results, menuProps) {
    let items = results.map((result, index) => {
      if (result.isCountry) {
        return (
          <Menu.Header key={index}>
            <span>{result.name}</span>
          </Menu.Header>
        )
      } else if (result.paginationOption) {
        return <MenuItem option={result} position={index} key={index}>{`${result.label}`}</MenuItem>
      } else {
        return <MenuItem option={result} position={index} key={index}>{`${result.name} (${result.code})`}</MenuItem>
      }
    })

    return <Menu {...menuProps}>{items}</Menu>
  }

  loadOptions() {
    if (this.state.regionsDataByCountry) {
      const regionsDataByCountry = this.state.regionsDataByCountry
      let sortedCountryCodes = RegionTools.getSortedCountryCodesByCountryName({ regionsDataByCountry })
      let processedData = []
      for (let i = 0; i < sortedCountryCodes.length; i++) {
        let actualCountryData = regionsDataByCountry[sortedCountryCodes[i]]
        actualCountryData.regions = RegionTools.getSortedRegionsByRegionName({ regionsData: actualCountryData.regions })

        let processedCountry = {
          countryCode: sortedCountryCodes[i],
          countryFullName: actualCountryData.countryFullName,
          code: sortedCountryCodes[i],
          name: actualCountryData.countryFullName,
          isCountry: true
        }
        processedData.push(processedCountry)
        actualCountryData.regions.forEach(region => {
          let processedRegion = region
          processedRegion.countryCode = sortedCountryCodes[i]
          processedRegion.countryFullName = actualCountryData.countryFullName
          processedRegion.isCountry = false
          processedData.push(processedRegion)
        })
      }
      return processedData
    }
    return []
  }

  renderIfAllOK() {
    if (this.state.loading) {
      return <Loading />
    } else {
      const actualURL = this.props.history.location.pathname
      const layer = APPURL.getLayerFromURL(actualURL)
      let placeholder = null
      if (layer === 0) {
        placeholder = this.formatMessage(messages.placeholder0)
      } else {
        placeholder = this.formatMessage(messages.placeholder1)
      }
      return (
        <Typeahead
          selected={[]}
          multiple={true}
          onChange={selected => this.handleChange(selected)}
          options={this.loadOptions()}
          labelKey={option => `${option.name} (${option.code})`}
          filterBy={['countryFullName', 'code']}
          renderMenu={this.renderMenu}
          selectHintOnEnter={true}
          placeholder={placeholder}
        />
      )
    }
  }

  render() {
    return <React.Fragment>{this.renderIfAllOK()}</React.Fragment>
  }
}
export default injectIntl(RegionChangerController)



// WEBPACK FOOTER //
// ./src/modules/Controllers/RegionChanger/RegionChangerController/RegionChangerController.jsx